import * as actions from './actions';

export default {
  strict: true,
  state: {
    isFetchingWidgets: false,
  },
  actions,
  mutations: {
    'webhooks/set': (state, { path, value }) => {
      state[path] = value;
    },
  },
};
